import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "./api";
import { MetadataStudioModal } from "./components/MetadataStudioModal";

export default function SemanticSettings({ onClose }) {
  const [status, setStatus] = useState(null);
  const [catalog, setCatalog] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [synonyms, setSynonyms] = useState(null);
  const [businessSemantic, setBusinessSemantic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const bootstrap = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [statusPayload, catalogPayload, metadataPayload, synonymPayload, businessPayload] = await Promise.all([
        api.getStatus().catch(() => null),
        api.getCatalog(),
        api.getMetadata(),
        api.getSynonyms(),
        api.getBusinessSemantic(),
      ]);
      setStatus(statusPayload);
      setCatalog(catalogPayload);
      setMetadata(metadataPayload);
      setSynonyms(synonymPayload);
      setBusinessSemantic(businessPayload);
    } catch (err) {
      setError(err.message || "Unable to load semantic settings");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  async function saveBusinessSemantic(payload) {
    const saved = await api.saveBusinessSemantic(payload);
    setBusinessSemantic(saved);
    toast.success("Business semantic saved");
    await bootstrap();
  }

  async function saveSynonym(kind, payload) {
    if (kind === "measure") await api.saveMeasureSynonyms(payload);
    if (kind === "dimension") await api.saveDimensionSynonyms(payload);
    if (kind === "value") await api.saveValueSynonyms(payload);
    const synonymPayload = await api.getSynonyms();
    setSynonyms(synonymPayload);
    toast.success("Synonyms saved");
  }

  return (
    <div className="semantic-ui-root admin-dashboard-view" style={{ minHeight: "calc(100vh - 120px)" }}>
      <div className="admin-title-wrapper">
        <div className="admin-title-left">
          <h2 className="admin-title">Semantic Settings</h2>
          <p className="admin-title-sub">
            Manage metadata, business semantic definitions, and synonyms for the semantic query engine.
          </p>
        </div>
        <div className="admin-title-right">
          <button className="nav-to-chat-btn" type="button" onClick={bootstrap} disabled={loading}>
            {loading ? "Loading..." : "Reload Semantic Metadata"}
          </button>
        </div>
      </div>

      {error ? (
        <div className="main-card" style={{ padding: 24, color: "#b91c1c", borderColor: "#fecaca", background: "#fff1f2" }}>
          {error}
        </div>
      ) : null}

      {loading && !metadata ? (
        <div className="main-card" style={{ padding: 40, color: "#6b7280" }}>
          Loading semantic metadata, business-semantic, and synonyms...
        </div>
      ) : (
        <MetadataStudioModal
          embedded
          onClose={onClose || (() => {})}
          catalog={catalog}
          metadata={metadata}
          synonyms={synonyms}
          onSave={saveSynonym}
          businessSemantic={businessSemantic}
          onSaveBusinessSemantic={saveBusinessSemantic}
        />
      )}
      {status?.datasetId ? (
        <div className="main-card" style={{ marginTop: 16, padding: 16, color: "#6b7280", fontSize: 12 }}>
          Semantic dataset: {status.datasetId}
        </div>
      ) : null}
    </div>
  );
}
